import React from 'react';
const CardHeader = ({ title, right }) => (
  <div className="d-flex justify-content-between align-items-center mb-2">
    <div className="text-uppercase small text-muted">{title}</div>
    {right && <div className="small text-muted">{right}</div>}
  </div>
);
export default CardHeader;